export default "__VITE_ASSET__Du58CNvp__"